import { getTranslatedText,useIsAuthorisedHook } from '@nile/components';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, TextStyle } from '@superops/ui-design-system';

function PatchCountCell(props) {
  const { cell, column, intl } = props;
  const isAllAssetPermission = useIsAuthorisedHook('allAssets.allow');

  const actions = cell.column.actions;

  const { editable = true } = cell.column;
  const client = cell.row?.original?.account;
  const site = cell.row?.original?.site;
  return cell.value ? (
    <Button
      plain={isAllAssetPermission}
      plainSecondary={!isAllAssetPermission}
      monochrome={!editable}
      disabled={!editable}
      onClick={() => {
        if (editable && isAllAssetPermission)
          actions.toggleSheetActive(
            column.id,
            cell.row.original.patchId,
            client,
            site,
            cell.row.original
          );
      }}
    >
      {cell.value}{' '}
      {getTranslatedText(intl, 'rmm.patchManagement.assetCount.postFix')}
    </Button>
  ) : (
    <TextStyle disabled>
      0 {getTranslatedText(intl, 'rmm.patchManagement.assetCount.postFix')}
    </TextStyle>
  );
}

export default injectIntl(PatchCountCell);
